<template>
	<div class="build-box">
		<el-collapse>
			<el-collapse-item title="简介" name="1">
				<p>记录本站搭建过程, 以供日后参考使用: </p>
				<i style="text-decoration: underline;">注意事项:</i>
				<p>1.Freenom需要国外IP才能正常访问. </p>
				<p>2.GitHub可以用Gitee替代. </p>
				<p>3.免费域名无法在国内备案, 不能绑定国内云服务器 (除香港). </p>
			</el-collapse-item>

			<el-collapse-item title="相关链接" name="2">
				<ul>
					<li>代码托管</li>
					<ul>
						<li>
							<el-link type="primary" href="https://github.com" target="_blank">GitHub</el-link>
						</li>
					</ul>
					<li>域名注册</li>
					<ul>
						<li>
							<el-link type="primary" href="https://www.freenom.com" target="_blank">Freenom</el-link>
						</li>
					</ul>
					<li>DNS解析</li>
					<ul>
						<li>
							<el-link type="primary" href="https://www.dnspod.cn" target="_blank">DNSPod</el-link>
						</li>
					</ul>
				</ul>
			</el-collapse-item>

			<el-collapse-item title="代码托管" name="3">
				<p>打开<a href="https://github.com" target="_blank">GitHub</a>网站, 注册登录后, 点击右上角'+'号, 选择创建新仓库 'New
					repository'. </p>
				<img src="../assets/build/git/new.jpg" />
				<p>新建仓库, 仓库名称为: 用户名.github.io, 然后点下方创建仓库. </p>
				<img src="../assets/build/git/create.jpg" />
				<p>下载安装<a href="https://desktop.github.com/" target="_blank">GitHub桌面版</a>, 方便接下来的操作.</p>
				<p>在客户端中登录GitHub账号后, 界面会显示已有的仓库, 选择刚刚创建好的仓库, 点击下方克隆仓库. </p>
				<img src="../assets/build/git/file.jpg" />
				<p>选择好要保存的本地路径后, 点击下方克隆. </p>
				<img src="../assets/build/git/clone.jpg">
				<p>打开保存的本地目录, 放入网站的相关文件(index.html). </p>
				<img src="../assets/build/git/add.jpg" />
				<p>回到客户端, GitHub已经自动获取到了目录的修改情况, 点击下方提交.</p>
				<img src="../assets/build/git/commit.jpg" />
				<p>最后, 依次点击右侧页面出现的蓝色按钮. </p>
				<img src="../assets/build/git/push.jpg" /><br />
				<img src="../assets/build/git/public.jpg" />
				<p>这时候, 浏览器访问 用户名.github.io 就可以查看自己的网站了. </p>
				<img src="../assets/build/git/open.jpg" />
			</el-collapse-item>

			<el-collapse-item title="域名注册" name="5">
				<p>Freenom提供tk、ml、ga、cf、gq为后缀的免费域名. </p>
				<p>首先, 打开<a href="https://www.freenom.com" target="_blank">Freenom</a>网站, 输入想要的域名名称 (不少于3个字母且不是特殊单词),
					检查可用性. </p>
				<img src="../assets/build/domain/check.jpg" />
				<p>选择可用的域名后缀(不可用说明已经被人注册), 如果都不可用就换个名称继续检查. </p>
				<img src="../assets/build/domain/select.jpg" />
				<p>选择好想要域名, 点击右侧获取, 加入购物车, 然后点击右上角结算. </p>
				<img src="../assets/build/domain/checkout.jpg" />
				<p>选择要购买的时长, 默认为3个月, 最多可购买12个月, 超过12个月则需要额外费用. </p>
				<img src="../assets/build/domain/period.jpg" />
				<p>确认订单. </p>
				<img src="../assets/build/domain/complete.jpg" />
				<p>显示如下结果, 则域名注册成功. </p>
				<img src="../assets/build/domain/confirm.jpg" />
				<p>域名到期前14天可免费续期. </p>
			</el-collapse-item>

			<el-collapse-item title="DNS解析" name="4">
				<p>虽然Freenom提供有域名解析服务 (是真的慢), 但使用国内的域名解析服务不仅方便管理, 也能提升访问速度. </p>
				<p>打开<a href="https://www.dnspod.cn" target="_blank">NDSPod</a>网站, 点击上方DNS, 选择DNS管理. </p>
				<img src="../assets/build/dns/dnspod.jpg" />
				<p>添加域名, 输入刚才注册的域名. </p>
				<img src="../assets/build/dns/add.jpg" />
				<p>此时, 显示域名状态异常. 根据提示, 回到Freenom进行设置. </p>
				<img src="../assets/build/dns/flash.jpg" />
				<p>回到Freenom, 点击右上角服务, 选择我的域 'My Domains'. </p>
				<img src="../assets/build/dns/mydomain.jpg" />
				<p>在域名列表中找到刚才注册的域名, 点击右侧管理域. </p>
				<img src="../assets/build/dns/manage.jpg" />
				<p>进入域名管理界面, 点击管理工具, 选择域名解析服务器 'Nameservers'. </p>
				<img src="../assets/build/dns/nameserve.jpg" />
				<p>选择使用自定义服务器, 将 f1g1ns1.dnspod.net 和 f1g1ns2.dnspod.net (DNSPod中提供的解析地址) 填入下面的输入框. </p>
				<img src="../assets/build/dns/change.jpg" />
				<p>更改完成后, 回到DNSPod, 刷新域名状态即可. </p>
			</el-collapse-item>

			<el-collapse-item title="域名绑定" name="6">
				<p>打开DNSPod, 找到刚刚解析的域名, 添加以下两条记录. </p>
				<img src="../assets/build/combine/add.jpg" />
				<p>在仓库目录下, 创建CNAME文件, 文件内容为域名地址. 然后打开GitHub客户端, 提交保存.</p>
				<img src="../assets/build/combine/cname.jpg" /><br />
				<img src="../assets/build/combine/content.jpg" />
				<p>现在, 就可以通过 域名 访问自己的网站了! </p>
				<img src="../assets/build/combine/open.jpg" />
			</el-collapse-item>
			
			<el-collapse-item title="域名续期" name="7">
				<p>域名即将到期时, 来到Freenom. </p>
				<p>点击右上角服务, 选择续订域 'Renew Domains'. </p>
				<img src="../assets/build/renew/renew.jpg" />
				<p>可续期的域名将显示为 'Renewable', 点击续订按钮. </p>
				<img src="../assets/build/renew/renewal.jpg" />
				<p>选择续订时长, 最多可续期12个月. </p>
				<img src="../assets/build/renew/period.jpg" />
				<p>提交订单后, 显示如下结果, 则域名续期成功. </p>
				<img src="../assets/build/renew/confirm.jpg" />
			</el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>
	export default {
		name: 'Build'
	}
</script>

<style>
	.build-box {
		width: 95%;
		padding: 10px 25px;
		margin: auto;
		min-height: 95%;
		border-radius: 5px;
		background-color: rgba(255, 255, 255, 0.9);
		animation: show 1.2s ease-in;
	}

	.build-box .el-collapse-item__header {
		padding: 0 10px;
		font-weight: bold;
		background-color: rgba(255, 255, 255, 0);
	}

	.build-box .el-collapse-item__wrap {
		padding: 0 20px;
		background-color: rgba(0, 0, 0, 0.1);
	}

	.build-box p {
		text-indent: 2em;
	}

	.build-box p a {
		text-decoration: none;
	}

	.build-box img {
		position: relative;
		left: 50%;
		transform: translate(-50%, 0%);
		max-width: 80%;
	}
	
	@media screen and (max-width: 700px) {
		.build-box {
			padding: 5px;
			width: 98%;
		}
	}
</style>
